import { BankDetailsNew_MX } from './mixed';

export const BankDetailsNew = {
  /**
   * FinancialProduct
   */
  FP: BankDetailsNew_MX,
  /**
   * PrivateLease
   */
  PL: BankDetailsNew_MX,
  /**
   * ServicePlan for Private
   */
  SP: BankDetailsNew_MX,
  /**
   * ServicePlan for Business
   */
  SPB: BankDetailsNew_MX,
  /**
   * OperatingLease
   */
  OL: BankDetailsNew_MX,
};
